import React, { useState, useEffect } from 'react'; 

import OperatorMappingModal from './OperatorMappingModal';
import CONSTANTS from '../../../../_constants/constants';
import { ApiService } from '../../../../_services/api.service';
import PageLayout from '../../../Layout/PageLayout/PageLayout';
import Alert from '../../../UI/Alert/Alert';
import Button from '../../../UI/Button/Button';
import Loader from '../../../UI/Loader/Loader';
import SearchBar from '../../../UI/SearchBar/SearchBar';
import Table from '../../../UI/Table/Table';
import classes from './OperatorMappingMaster.module.css';

const OperatorMappingMasterPage = () => {

    const [isLoading, setIsLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState(null);
    const [gridData, setGridData] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modalName, setModalName] = useState('');
    const [modalData, setModalData] = useState({});
    const [filterKeyword, setFilterKeyword] = useState('');
    
    const tableHeaders = ['Operator Mapping Name', 'Operator'];
    const dataFields = ['operatorMapName', 'operatorName'];
    const tableConfig = {
        headerAlignConfig: {
            'Operator Mapping Name': 'left',
            'Operator': 'center'
        },
        widthConfig: {
            'Operator Mapping Name': 'auto',
            'Operator': '186px'
        },
        alignConfig: {
            'operatorMapName': 'left',
            'operatorName': 'left'
        }
    }
    
    useEffect(() => {
        getOperatorMappingData();
    }, []);
    
    const modalCloseHandler = status => {
        setModalIsOpen(false);
        if(status === 'save') {
            getOperatorMappingData();
        }
    }

    const getOperatorMappingData = () => {
        const url = `${CONSTANTS.API_URL}OperatorMap/AllOperatorMap`;
        ApiService.getData(url).then(
            result => {
                if(result.data) {
                    setIsLoading(false);
                    setGridData(result.data.results);
                    setPageCount(Math.ceil(result.data.results.length/10));
                } else {
                    setIsLoading(false);
                    setErrorMessage(result.error.message);
                }
            },
            error => {
                setIsLoading(false);
                setErrorMessage(error);
            }
        );
    }

    const modalOpenHandler = (modalName, modalData) => {
        setModalIsOpen(true);
        setModalName(modalName);
        modalData === '' ? setModalData({}) : setModalData(modalData);
    }
    
    const handleAfterOpen = (event, data) => console.log(event, data)

    const filterKeywordChangeHandler = event => setFilterKeyword(event.target.value);

    const filterDataHandler = filteredData => {
        return filteredData.filter( data =>
            data.operatorMapName && data.operatorMapName.toLowerCase().includes(filterKeyword.toLowerCase()) ||
            data.operatorName && data.operatorName.toLowerCase().includes(filterKeyword.toLowerCase())
        )
    }

    return (
        <>
            { isLoading && <Loader /> }
            { !isLoading && (
                <PageLayout pageTitle='Operator Mapping Master'>
                    <div className='row mb-3'>
                        <div className={`col-12 ${classes.headerActions}`}>
                            <SearchBar onFilterKeywordChange={filterKeywordChangeHandler} />
                            <div>
                                <Button btnClass='btn btn-primary' onClick={e => modalOpenHandler('Add', '')} btnText='Add Operator Mapping Name' btnTitle='Add Operator Mapping Name' btnType='Add' />
                                <OperatorMappingModal
                                    modalData={modalData}
                                    modalName={modalName}
                                    isModalOpened={modalIsOpen}
                                    onCloseModal={modalCloseHandler}
                                    onAfterOpen={handleAfterOpen}
                                />
                            </div>
                        </div>
                    </div>
                    { errorMessage && <Alert alertClassName='danger' message={errorMessage} /> }
                    <Table 
                        tableHeaders={tableHeaders} 
                        dataFields={dataFields} 
                        tableConfig={tableConfig}
                        pageCount={pageCount} 
                        onModalOpen={modalOpenHandler} 
                        sort={true}
                        actions={true}
                        edit={true} 
                        delete={true} 
                        filter={true}
                        paginate={false}
                        rowClick={false}
                        gridData={gridData}
                        filterKeyword={filterKeyword}
                        onFilterData={filterDataHandler}
                    />
                </PageLayout>
            )}    
        </>
    );
  
}

export default OperatorMappingMasterPage;